import useAppStore from "@/context/store";
import { getUserFavoriteBoards } from "@/services";
import { useMount, useSafeState } from "ahooks";
import { useCallback } from "react";
import BoardList from "../../../BoardList";
import Empty from "../Empty";
import Loading from "../Loading";

export default function MyFavoriteBoardList({ user, initLikesBoards }) {
  const [records, setRecords] = useSafeState(initLikesBoards || []);
  const [hasMore, setHasMore] = useSafeState(true);
  const [loading, setLoading] = useSafeState(!initLikesBoards);
  const currentUser = useAppStore((s) => s.user);

  const loadData = useCallback(
    async (currentRecords) => {
      setLoading(true);
      currentRecords = currentRecords || records;
      const PAGE_SIZE = 30;

      const params = {
        username: user.urlname,
        max: currentRecords[currentRecords.length - 1]?.seq,
        limit: PAGE_SIZE,
      };
      const {
        err,
        user: { likes_boards: boards },
      } = await getUserFavoriteBoards(params);
      setLoading(false);
      if (err) return;

      if (boards.length < PAGE_SIZE) setHasMore(false);

      setRecords([...currentRecords.concat(boards)]);
    },
    [records, setHasMore, setLoading, setRecords, user.urlname]
  );

  useMount(async () => {
    if (!initLikesBoards || !initLikesBoards.length) {
      await loadData([]);
    }
  });

  if (loading && !records.length) {
    return <Loading />;
  }

  const isMe = user.urlname === currentUser?.urlname;

  return records.length ? (
    <BoardList
      dataSource={records}
      onLoadMore={loadData}
      hideUser
      hasMore={hasMore}
      showLikeBtn={isMe}
    />
  ) : (
    <Empty
      imageUrl={
        "https://cdn.dancf.com/fe-assets/img/a52cf2370b7c7f53c751dfcd154fcbde.png"
      }
      title={"还没有喜欢的画板哦～"}
    />
  );
}
